<script>
import SideMenu from '@/components/schools/common/SideMenu';
// import NavBar from '@/components/schools/common/NavBar';
import NavBar from '@/components/NavBar';

export default {
  name: 'ApplicationLayout',
  components: {
    SideMenu,
    NavBar,
  },
  data() {
    return {

    };
  },
};
</script>

<template lang="pug">
.application
  nav-bar.header
  .body
    .side-menu
      side-menu
    .main-content
      slot
</template>

<style lang="stylus" scoped>
.application
  height 100%
  width 100%
  padding-left 220px
  padding-top 60px
  box-sizing border-box
  position relative
  .header
    position fixed
    top 0
    left 0
    width 100%
    background #2f4157
    z-index 99
  .body
    display flex
  .side-menu
    position fixed
    top 56px
    bottom 0px
    width 220px
    margin-left -220px
    z-index 1
  .main-content
    box-sizing border-box
    display flex
    position relative
    float left
    width 100%
    height 100%
    overflow auto
</style>



// WEBPACK FOOTER //
// SchoolLayout.vue?49ae4b57